import React, { FunctionComponent } from 'react';
import HelpStyles from '../../Help.module.scss';

const IOSComponent: FunctionComponent = () => {
  return (
    <div className={HelpStyles.sharedHelpStyles}>
      <div className={HelpStyles.steps}>
        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>1</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Go to <strong>Settings</strong> → <strong>Privacy & Security</strong> → <strong>Location Services</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>2</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Turn on <strong>Location Services</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>3</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Scroll down to find <strong>Safari Websites</strong> and set to <strong>While Using App</strong> or <strong>Always</strong>
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>4</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              For other browsers, find the browser app name and enable location access
            </p>
          </div>
        </div>

        <div className={HelpStyles.step}>
          <div className={HelpStyles.stepNumber}>5</div>
          <div className={HelpStyles.stepContent}>
            <p className="fontFourteen poppins-regular text-black mb-5">
              Ensure <strong>Precise Location</strong> is enabled for better accuracy
            </p>
          </div>
        </div>
      </div>

      <div className={HelpStyles.tip}>
        <div className={HelpStyles.tipIcon}>💡</div>
        <div className={HelpStyles.tipContent}>
          <p className="fontFourteen poppins-regular text-gray">
            <strong>Tip:</strong> If you don't see your browser in the list, try opening it first and allowing location access when prompted.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IOSComponent;